const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

const PAGE_TYPES = ANALYTICS_EVENTS.PAYLOADS.pageDesigner.pageType;

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
/* -------------------------------------------------------------------------- *\
 * HOME EVENTS                                                                *
\* -------------------------------------------------------------------------- */

  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.pageDesignerComponentClicked,
    ({
      additionalParam,
      clickedDescendantPosition = undefined,
      name = '',
      pageType,
      position,
      type,
    }) => {
      const eventName = PAGE_TYPES[pageType];
      if (!eventName) return;
      const eventDataArray = [
        ['type', 'click'],
        ['module_name', name],
        ['position', position],
        ['module_type', type],
      ];
      eventDataArray.push(
        additionalParam || ['internal_position', clickedDescendantPosition]
      );
      pushEvent(createCustomEventGA4(eventName, eventDataArray));
    }
  );

  /* -------------------------------------------------------------------------- *\
 * PAGE DESIGNER POPUP EVENTS                                                  *
 * - Opened (view)                                                             *
 * - Closed (close)                                                            *
 * - CTA clicked (click)                                                       *
\* -------------------------------------------------------------------------- */

  // Page Designer popup is shown
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.pageDesignerPopUpOpened,
    ({ campaign }) => {
      pushEvent(
        createCustomEventGA4('popup_custom', [
          ['action', 'view'],
          ['message', campaign],
        ])
      );
    }
  );

  // Page Designer popup is closed
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.pageDesignerPopUpClosed,
    ({ campaign }) => {
      pushEvent(
        createCustomEventGA4('popup_custom', [
          ['action', 'close'],
          ['message', campaign],
        ])
      );
    }
  );

  // Page Designer popup CTA link is clicked
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.pageDesignerPopUpCtaClicked,
    ({ campaign }) => {
      pushEvent(
        createCustomEventGA4('popup_custom', [
          ['action', 'click'],
          ['message', campaign],
        ])
      );
    }
  );

  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.pageDesignerComponentImpressionViewed,
    ({ name = '', pageType, position, type }) => {
      const eventName = PAGE_TYPES[pageType];
      if (!eventName) return;
      gaInfo.pageType = pageType;
      pushEvent(
        createCustomEventGA4(eventName, [
          ['type', 'impression'],
          ['module_name', name],
          ['position', position],
          ['module_type', type],
        ])
      );
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
